/**
 * Do not edit directly
 * Generated on Wed, 17 Jan 2024 06:57:36 GMT
 */

export const colorNeutral100 = "#fff";
export const colorNeutral200 = "#F5F3F6";
export const colorNeutral300 = "#D8D6D9";
export const colorNeutral400 = "#BCB9BE";
export const colorNeutral500 = "#8A858E";
export const colorNeutral600 = "#726F74";
export const colorNeutral700 = "#4C494E";
export const colorNeutral800 = "#333234"; // text
export const colorPrimary100 = "#E5ECFF";
export const colorPrimary200 = "#B2C6FF";
export const colorPrimary300 = "#809FFF";
export const colorPrimary400 = "#0040FF";
export const colorPrimary500 = "#002699";
export const colorSuccess100 = "#E5F1ED";
export const colorSuccess200 = "#E5F1ED";
export const colorSuccess300 = "#4CB176";
export const colorSuccess400 = "#0B883D";
export const colorAlert100 = "#F6E3EB";
export const colorAlert200 = "#EBB4C4";
export const colorAlert300 = "#D04A6B";
export const colorAlert400 = "#A60C31";
export const colorWarning100 = "#FBEEEA";
export const colorWarning200 = "#FAD5C1";
export const colorWarning300 = "#F69C64";
export const colorWarning400 = "#F47C31";
export const colorInfo100 = "#E3ECFB";
export const colorInfo200 = "#B0CEF4";
export const colorInfo300 = "#3F8AE2";
export const colorInfo400 = "#015BC5";
export const colorSkandv1100 = "#FEF6F0";
export const colorSkandv1200 = "#FCD7C0";
export const colorSkandv1300 = "#F9B890";
export const colorSkandv1400 = "#F47C31";
export const colorSkandv1500 = "#CB550B";
export const fontFamilyRaleway = "Raleway";
export const fontFamilyRoboto = "Roboto";
export const fontWeightRegular = 400;
export const fontWeightSemiBold = 600;
export const fontSizeHeadingOne = "56px";
export const fontSizeHeadingTwo = "40px";
export const fontSizeHeadingThree = "28px";
export const fontSizeTextLarge = "20px";
export const fontSizeTextMedium = "16px";
export const fontSizeTextSmall = "12px";
export const fontSizeTextXs = "10px";
export const fontSizeTextXxs = "8px";
export const lineHeightHeadingOne = "64px";
export const lineHeightHeadingTwo = "48px";
export const lineHeightHeadingThree = "32px";
export const lineHeightTextLarge = "24px";
export const lineHeightTextMedium = "20px";
export const lineHeightTextSmall = "16px";
export const lineHeightTextXs = "14px";
export const lineHeightTextXxs = "12px";
export const typographyHeadingOne = "400 56px/64px Raleway";
export const typographyHeadingTwo = "400 40px/48px Raleway";
export const typographyHeadingThree = "600 28px/32px Raleway";
export const typographyHeadingFour = "600 20px/24px Raleway";
export const typographyTextLarge = "400 20px/24px Roboto";
export const typographyTextMedium = "400 16px/20px Roboto";
export const typographyTextMediumEmphasis = "600 16px/20px Roboto"; // Selected
export const typographyTextSmall = "400 12px/20px Roboto";
export const typographyTextSmallEmphasis = "600 12px/20px Roboto"; // Selected
export const typographyTextXs = "400 10px/14px Roboto";
export const typographyTextXsEmphasis = "600 10px/14px Roboto"; // Selected
export const typographyTextXsButton = "600 10px/14px Roboto"; // xs buttons
export const typographyTextXxs = "400 8px/12px Roboto"; // field labels
export const typographyTextXxsEmphasis = "600 8px/12px Roboto"; // selected
export const typographyLinkMedium = "600 16px/20px Roboto";
export const typographyLinkSmall = "600 12px/16px Roboto";
export const typographyLinkXs = "600 10px/14px Roboto";
export const typographyLinkXxs = "600 8px/12px Roboto"; // field labels
export const spacing1x = "4px";
export const spacing2x = "8px";
export const spacing3x = "12px";
export const spacing4x = "16px";
export const spacing5x = "20px";
export const spacing6x = "24px";
export const spacing7x = "28px";
export const spacing8x = "32px";
export const borderRadius1x = "4px";
export const borderRadius2x = "8px";
export const borderRadius3x = "12px";
export const borderRadius4x = "16px";
export const uppercase = "uppercase";
export const underline = "underline";
export const tokenSetOrder0 = "skand";
